import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { NonStaticContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Avatar = styled.div<{
    $background: COLORS | 'transparent',
}>`
    background: ${({ $background }) => $background};
    border-radius: 50%;
    align-self: flex-end;
    width: 64px;
    height: 64px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 32px;
        height: 32px;
    }
`;

export const MessageBody = styled(RounderContainer)<{
    $background: COLORS,
    $maxWidth: number,
    $color: COLORS,
}>`
    background: ${({ $background }) => $background};
    color: ${({ $color }) => $color};
    max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
    overflow: hidden;
`;

export const MessageTailContainer = styled(NonStaticContainer)<{
    $rotate: number,
}>`
    transform: rotateY(${({ $rotate }) => $rotate}deg);
`;
